/** Whether a pivot value filter ranks across the whole axis or inside each member of the outer field. */
export enum PivotValueFilterScopeEnum {
  overall = 'overall',
  perParent = 'perParent',
}
